import { AxiosResponse } from 'axios';
import { useGenerateNotificationKey } from 'pages/Merchants/hooks/useGenerateNotificationKey';
import { useGetPlatforms } from 'pages/Merchants/hooks/useGetPlatforms';
import { useNotificationKeyValidation } from 'pages/Merchants/hooks/useNotificationKeyValidation';
import { required } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import {
  AutocompleteInput,
  BooleanInput,
  KeyInputIntrospected,
  TextInputIntrospected,
  TextInputWithAliasIntrospected,
  AutocompleteMultiselectInput,
  SelectInput,
} from 'shared/react-admin/Inputs';
import {
  ReferenceArrayInputIntrospected,
  ReferenceInputIntrospected,
} from 'shared/react-admin/ReferenceInputs';
import { Referral } from 'types/embedded/referral';

import { BoxStyled } from './MerchantsCreate.styled';

export const MerchantsCreateForm = () => {
  const { setValue, clearErrors } = useFormContext();
  const { generateNotificationKey } = useGenerateNotificationKey({
    onSuccess: (data: AxiosResponse) => {
      clearErrors('notificationKey');
      setValue('notificationKey', data.data.value);
    },
  });
  const { notificationKeyValidation } = useNotificationKeyValidation();
  const platforms = useGetPlatforms();

  return (
    <BoxStyled>
      <TextInputIntrospected
        fullWidth
        label="Название"
        size="small"
        source="name"
        variant="outlined"
      />
      <TextInputWithAliasIntrospected
        fullWidth
        label="Алиас"
        size="small"
        source="alias"
        variant="outlined"
      />
      <KeyInputIntrospected
        fullWidth
        label="Ключ нотификации"
        onClickGenerateKey={generateNotificationKey}
        size="small"
        source="notificationKey"
        validate={[required(), notificationKeyValidation]}
        variant="outlined"
      />
      <TextInputIntrospected
        fullWidth
        label="ID канала для missMatch уведомлений"
        size="small"
        source="missmatchChatId"
        variant="outlined"
      />
      <ReferenceInputIntrospected reference="languages" source="language">
        <AutocompleteInput
          label="Язык уведомлений"
          name="language"
          optionText="description"
          size="small"
          validate={required()}
          variant="outlined"
        />
      </ReferenceInputIntrospected>
      <ReferenceArrayInputIntrospected
        filter={{ archive: false }}
        perPage={200}
        reference="companies"
        source="companies"
      >
        <AutocompleteMultiselectInput
          helperText={false}
          label="Компании"
          name="companies"
          optionText="name"
          size="small"
        />
      </ReferenceArrayInputIntrospected>
      <ReferenceArrayInputIntrospected perPage={200} reference="referrals" source="referrals">
        <AutocompleteMultiselectInput
          filterToQuery={(searchText: string) => {
            if (!isNaN(Number(searchText))) {
              return { refId: searchText };
            }
            return { name: searchText };
          }}
          getOptionLabel={(record: Referral) => `${record?.refId}: ${record?.name}`}
          helperText={false}
          label="Рефералы"
          name="referrals"
          size="small"
          sx={{ marginBottom: '24px' }}
        />
      </ReferenceArrayInputIntrospected>
      <SelectInput
        choices={platforms}
        fullWidth
        helperText={false}
        label="Платформа"
        name="platform"
        optionText="label"
        size="small"
        source="platform"
        sx={{ marginBottom: '24px!important' }}
        validate={required()}
        variant="outlined"
      />
      <BooleanInput
        label="Партнерство"
        size="small"
        source="partner"
        sx={{ marginTop: '8px', marginLeft: '7px' }}
      />
    </BoxStyled>
  );
};
